export const cilBriefcase = ["24 24","<path d='M22.089 5.237h-4.839v-4.487h-10.489l0 4.487h-4.828c-0.641 0.001-1.16 0.52-1.161 1.161v15.658c0.001 0.641 0.52 1.16 1.161 1.161h20.156c0.641-0.001 1.16-0.52 1.161-1.161v-15.658c-0.001-0.641-0.52-1.16-1.161-1.161h-0zM8.261 2.25h7.489v2.987h-7.489zM21.678 6.809v3.763l-2.493 2.493h-6.388v-2.191h-1.572v2.191h-6.388l-2.493-2.493v-3.763zM2.344 21.645v-8.849l1.842 1.842h7.040v2.214h1.572v-2.214h7.040l1.842-1.842v8.849z'></path>"]


//////////////////
// WEBPACK FOOTER
// ./node_modules/@coreui/icons/js/free/cil-briefcase.js
// module id = null
// module chunks = 